import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const GooglePayEnabledMedium = (props: FlagsSvgProps) => {
  return (
    <Svg width={60} height={32} viewBox="0 0 60 32" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_3784" fill="white">
        <Path d="M0 16C0 7.16344 7.16344 0 16 0H44C52.8366 0 60 7.16344 60 16C60 24.8366 52.8366 32 44 32H16C7.16344 32 0 24.8366 0 16Z" />
      </Mask>
      <Path
        d="M0 16C0 7.16344 7.16344 0 16 0H44C52.8366 0 60 7.16344 60 16C60 24.8366 52.8366 32 44 32H16C7.16344 32 0 24.8366 0 16Z"
        fill="white"
      />
      <Path
        d="M16 0V1H44V0V-1H16V0ZM44 32V31H16V32V33H44V32ZM16 32V31C7.71573 31 1 24.2843 1 16H0H-1C-1 25.3888 6.61116 33 16 33V32ZM60 16H59C59 24.2843 52.2843 31 44 31V32V33C53.3888 33 61 25.3888 61 16H60ZM44 0V1C52.2843 1 59 7.71573 59 16H60H61C61 6.61116 53.3888 -1 44 -1V0ZM16 0V-1C6.61116 -1 -1 6.61116 -1 16H0H1C1 7.71573 7.71573 1 16 1V0Z"
        fill="#303030"
        mask="url(#path-1-inside-1_22078_3784)"
      />
      <Path
        d="M28.5281 17.136V21.976H26.9921V10.024H31.0641C32.0961 10.024 32.9761 10.368 33.6961 11.056C34.4321 11.744 34.8001 12.584 34.8001 13.576C34.8001 14.592 34.4321 15.432 33.6961 16.112C32.9841 16.792 32.1041 17.128 31.0641 17.128H28.5281V17.136ZM28.5281 11.496V15.664H31.0961C31.7041 15.664 32.2161 15.456 32.6161 15.048C33.0241 14.64 33.2321 14.144 33.2321 13.584C33.2321 13.032 33.0241 12.544 32.6161 12.136C32.2161 11.712 31.7121 11.504 31.0961 11.504H28.5281V11.496Z"
        fill="#3C4043"
      />
      <Path
        d="M38.8162 13.5282C39.9522 13.5282 40.8482 13.8322 41.5042 14.4402C42.1602 15.0482 42.4882 15.8802 42.4882 16.9362V21.9762H41.0242V20.8402H40.9602C40.3282 21.7762 39.4802 22.2402 38.4242 22.2402C37.5202 22.2402 36.7682 21.9762 36.1602 21.4402C35.5522 20.9042 35.2482 20.2402 35.2482 19.4402C35.2482 18.5922 35.5682 17.9202 36.2082 17.4242C36.8482 16.9202 37.7042 16.6722 38.7682 16.6722C39.6802 16.6722 40.4322 16.8402 41.0162 17.1762V16.8242C41.0162 16.2882 40.8082 15.8402 40.3842 15.4642C39.9602 15.0882 39.4642 14.9042 38.8962 14.9042C38.0402 14.9042 37.3602 15.2642 36.8642 15.9922L35.5122 15.1442C36.2562 14.0642 37.3602 13.5282 38.8162 13.5282ZM36.8322 19.4642C36.8322 19.8642 37.0002 20.2002 37.3442 20.4642C37.6802 20.7282 38.0802 20.8642 38.5362 20.8642C39.1842 20.8642 39.7602 20.6242 40.2642 20.1442C40.7682 19.6642 41.0242 19.1042 41.0242 18.4562C40.5442 18.0802 39.8802 17.8882 39.0242 17.8882C38.4002 17.8882 37.8802 18.0402 37.4642 18.3362C37.0402 18.6482 36.8322 19.0242 36.8322 19.4642Z"
        fill="#3C4043"
      />
      <Path
        d="M50.8402 13.7922L45.7202 25.5682H44.1362L46.0402 21.4482L42.6642 13.7922H44.3362L46.7682 19.6642H46.8002L49.1682 13.7922H50.8402Z"
        fill="#3C4043"
      />
      <Path
        d="M22.4184 16.16C22.4184 15.6592 22.3736 15.18 22.2904 14.7192H15.8521V17.3592L19.5601 17.36C19.4097 18.2384 18.9257 18.9872 18.1841 19.4864V21.1992H20.3913C21.68 20.0064 22.4184 18.2432 22.4184 16.16Z"
        fill="#4285F4"
      />
      <Path
        d="M18.1849 19.4865C17.5705 19.9009 16.7793 20.1433 15.8537 20.1433C14.0657 20.1433 12.5489 18.9385 12.0057 17.3145H9.72888V19.0809C10.8569 21.3193 13.1753 22.8553 15.8537 22.8553C17.7049 22.8553 19.2601 22.2465 20.3921 21.1985L18.1849 19.4865Z"
        fill="#34A853"
      />
      <Path
        d="M11.7912 16.0042C11.7912 15.5482 11.8672 15.1074 12.0056 14.693V12.9266H9.7288C9.2624 13.8522 9 14.897 9 16.0042C9 17.1114 9.2632 18.1562 9.7288 19.0818L12.0056 17.3154C11.8672 16.901 11.7912 16.4602 11.7912 16.0042Z"
        fill="#FABB05"
      />
      <Path
        d="M15.8537 11.8642C16.8641 11.8642 17.7689 12.2122 18.4833 12.8922L20.4393 10.9378C19.2513 9.83136 17.7025 9.15216 15.8537 9.15216C13.1761 9.15216 10.8569 10.6882 9.72888 12.9266L12.0057 14.693C12.5489 13.069 14.0657 11.8642 15.8537 11.8642Z"
        fill="#E94235"
      />
    </Svg>
  )
}
